import { Base } from './base';

export class ParkingLot extends Base {
    ParkingLotID?: number;
    AuthorID?: number;
    ParkingID?: number;
    ParkingLotStatID?: number;
    Latitude?: number;
    Longitude?: number;
    No?: string;
    Distance?: number;
    IsHandicapped?: boolean;
    Description?: string;

    // Model properties
    SensorRegistrationNumber?: string;

    // Web properties
    IsIdEditable?: boolean;
    IsNoEditable?: boolean;
    IsSelected?: boolean;

    // Constructors
    constructor(
        no?: string,
        latitude?: number,
        longitude?: number,
        isHandicapped?: boolean,
        sensorRegistrationNumber?: string,

        isIdEditable?: boolean,
        isNoEditable?: boolean,
        isSelected?: boolean
    ) {
        super();
        this.No = no;
        this.Latitude = latitude;
        this.Longitude = longitude;
        this.IsHandicapped = isHandicapped;
        this.SensorRegistrationNumber = sensorRegistrationNumber;

        this.IsIdEditable = isIdEditable;
        this.IsNoEditable = isNoEditable;
        this.IsSelected = isSelected;
    }
}

export interface IParkingLot {
    parkingLotID: number;
    parkingID: number;
    parkingLotStatID: number;
    parkingLotTypeID: number;
    nedapGroupID: string;
    no: string;
    latitude: number;
    longitude: number;
}

export interface IParkingLotGroup {
    groupID: string;
    total: number;
    free: number;
    occupied: number;
    booked: number;
    parkingLots: IParkingLot[];
}
